import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import LandingPage from "./LandingPage";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>
);

// HTML pré-rendu par react-snap : hydratation via l'API legacy, tolérante aux
// différences d'attributs (classes responsive calculées via window.innerWidth,
// styles framer-motion) que hydrateRoot (React 18 strict) refuse.
// Sinon (npm start) : rendu classique.
if (container.hasChildNodes()) {
  ReactDOM.hydrate(app, container);
} else {
  createRoot(container).render(app);
}